<template>
  <!-- 休暇申請 -->
  <div>
    <CCard>
      <CCardHeader>
        <h2>休暇申請詳細</h2>
      </CCardHeader>
      <CCardBody>
        <ValidationObserver ref="obs">
          <CRow>
            <div class="container">
              <table class="table">
                <tr>
                  <th scope="row">申請日</th>
                  <td>{{ updated_at }}</td>
                </tr>
                <tr>
                  <th scope="row">プロジェクト名</th>
                  <td>{{ project_name }}</td>
                </tr>
                <tr>
                  <th scope="row">種別</th>
                  <td>
                    <span>{{ getTypeName(type) }}</span>
                  </td>
                </tr>
                <tr>
                  <th scope="row">開始日</th>
                  <td>{{ formatDate(start_day) }}【{{ getDayName(start_time) }}】</td>
                </tr>
                <tr>
                  <th scope="row">終了日</th>
                  <td>{{ (end_day!=null && end_time!=null &&(start_day !== end_day || start_time !== end_time)) ? formatDate(end_day)+"【"+end_time+"】"  : '単日取得' }}</td>
                </tr>
                <tr>
                  <th scope="row">備考・事由など</th>
                  <td>{{ reason }}</td>
                </tr>
                <tr>
                  <th scope="row">連絡先(電話番号等)</th>
                  <td>{{ telephone }}</td>
                </tr>
                <tr>
                  <th scope="row">事前承認済</th>
                  <td>
                    <div class="d-flex flex-column">
                      <div class="d-flex align-items-center mb-2">
                        <label class="custom-switch mb-0">
                          <input
                            type="checkbox"
                            class="custom-switch-input"
                            id="mgr-approved"
                            v-model="manager_approval"
                            disabled
                          />
                          <span class="custom-switch-indicator" aria-hidden="true"></span>
                        </label>
                        <label for="mgr-approved" class="ml-2 mb-0">弊社上長</label>
                      </div>
                      <div class="d-flex align-items-center">
                        <label class="custom-switch mb-0">
                          <input
                            type="checkbox"
                            class="custom-switch-input"
                            id="sup-approved"
                            v-model="supervisor_approval"
                            disabled
                          />
                          <span class="custom-switch-indicator" aria-hidden="true"></span>
                        </label>
                        <label for="sup-approved" class="ml-2 mb-0">現場上長（お客様含む）</label>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
              <CRow class="mt-3 align-items-center">
                <CCol class="text-start">
                  <router-link :to="{ name: paidAndSudstituteList }">
                    <button class="btn btn-secondary">戻る</button>
                  </router-link>
                </CCol>
                <CCol class="text-center">
                  <router-link :to="{ name: paidAndSudstituteEdit, params: { value: $route.params.value } }">
                    <button class="btn btn-info">編集</button>
                  </router-link>
                </CCol>
                <CCol></CCol>
              </CRow>
            </div>
          </CRow>
        </ValidationObserver>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import ConstList from "../../ConstList";
import axios from "axios";
export default {
  name: "PaidAndSubstitute",
  data() {
    return {
      updated_at: "",
      project_name: "",
      date: "",
      name: "",
      type: "",
      type_options: [
        {
          id: ConstList.PAID_ID,
          name: ConstList.PAID_NAME
        },
        {
          id: ConstList.SUBSTITUTE_ID,
          name: ConstList.SUBSTITUTE_NAME
        },
        {
          id: ConstList.SPECIAL_ID,
          name: ConstList.SPECIAL
        }
      ],
      start_day: "",
      start_time: "",
      end_day: "",
      end_time: "",
      days: [
        {
          id: ConstList.ALLDAY_ID,
          name: ConstList.ALLDAY
        },
        {
          id: ConstList.MORNING_ID,
          name: ConstList.MORNING
        },
        {
          id: ConstList.AFTERNOON_ID,
          name: ConstList.AFTERNOON
        }
      ],
      reason: "",
      telephone: "",
      approval_type:"",
      manager_approval: false,
      supervisor_approval: false,
      paidAndSudstituteList: "",
      paidAndSudstituteEdit: ""
    };
  },

created() {
        this.paidAndSudstituteList = ConstList.ROUTE_PAIDANDSUDSTITUTE_LIST;
        this.paidAndSudstituteEdit = ConstList.ROUTE_PAIDANDSUDSTITUTE_EDIT;
      },

  mounted: function() {
    this.id = this.$route.params.id;
    const id = parseInt(this.id);
    {
      axios
        .get(process.env.VUE_APP_API_ORIGIN + "/paidandsubstitute/" + id)
        .then(response => {
          if (response.data === 0) {
            this.errors.push(ConstList.EMPTY);
          }
          const userData = response.data;
          this.project_name = userData.project_name;
          this.start_day = userData.start_day;
          this.start_time = userData.start_time;
          this.end_day = userData.end_day;
          this.end_time = userData.end_time;
          this.type = userData.type;
          this.updated_at = userData.updated_at;
          this.reason = userData.reason;
          this.telephone = userData.telephone;
          this.approval_type = userData.approval_type;
          if (this.approval_type === ConstList.MANAGER_APPROVAL_ID){
            this.manager_approval = true;
            this.supervisor_approval = false;
          }
          else if (this.approval_type === ConstList.SUPERVISOR_APPROVAL_ID){
            this.manager_approval = false;
            this.supervisor_approval = true;
          }
          else if (this.approval_type === ConstList.BOTH_APPROVAL_ID){
            this.manager_approval = true;
            this.supervisor_approval = true;
          }
          else if(this.approval_type === ConstList.NOT_SELECTED_ID) {
            this.manager_approval = false;
            this.supervisor_approval = false;
          }
        })
        .catch(error => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        });
    }
  },

  methods: {
    apply: function() {
      if (this.start_time === (ConstList.ALLDAY_ID || ConstList.MORNING_ID)) {
        this.start_day = this.start_day + " 00:00:00";
      }
      if (this.start_time === ConstList.AFTERNOON_ID) {
        this.start_day = this.start_day + " 13:00:00";
      }
      if (this.end_time === (ConstList.ALLDAY_ID || ConstList.AFTERNOON_ID)) {
        this.end_day = this.end_day + " 23:59:59";
      }
      if (this.end_time === ConstList.MORNING_ID) {
        this.end_day = this.end_day + " 12:00:00";
      }
      const params = new URLSearchParams();
      params.append(ConstList.START_HOLIDAY, this.start_day);
      params.append(ConstList.END_HOLIDAY, this.end_day);
      params.append(ConstList.HOLIDAY_TYPE, this.type);
      params.append(ConstList.HOLIDAY_REASON, this.reason);
      params.append(ConstList.APPROVAL_TYPE, this.approval_type);
      params.append(ConstList.DELETED_FLG, 0);
      axios
        .post(process.env.VUE_APP_API_ORIGIN + "/applyholiday", params)
        .then(response => {
          if (response.data === ConstList.SUCCESS) {
            alert(ConstList.REGISTER_MESSAGE);
          } else {
            alert(ConstList.APPLY_ERROR);
          }
        })
        .catch(error => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          });
        });
    },
    autoTimeSet: function() {
      let start = this.start_time;
      let end = this.end_time;
      if (
        this.start_day !== "" &&
        this.end_day !== "" &&
        this.start_day !== this.end_day
      ) {
        start.splice(0, 1, ConstList.ALLDAY_ID);
        end.splice(0, 1, ConstList.ALLDAY_ID);
      }
    },
    // 種別IDを名称に変換
    getTypeName(id) {
      const option = this.type_options.find(o => o.id === id);
      return option ? option.name : id;
    },
    formatDate(dateStr) {
    // yyyy/mm/ddフォーマット変換
    if (!dateStr) return '';
      const [yyyy, mm, dd] = dateStr.split('-');
      return `${yyyy}/${mm}/${dd}`;
    },
    // 時間帯IDを名称に変換
    getDayName(id) {
      const option = this.days.find(o => o.id === id);
      return option ? option.name : id;
    },
  }
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}
.container {
  margin-left: 0%;
}
</style>
